import React, { Component } from 'react';

interface IProps {
  src: string;
  alt: string;
}

interface IState {
  width: string;
  height: string;
  src?: string;
}

export default class Image extends Component<IProps, IState> {
  state = {
    width: '100%',
    height: 'auto',
    src: undefined,
  };

  private onImgLoad = _ => {
    this.setState({
      src: this.props.src,
    });
  };

  private onImgLoadError = () => {};

  componentDidMount(): void {
    this.setState({
      src: this.props.src,
    });
  }

  render() {
    const {
      props: { alt },
      state: { src },
    } = this;

    // TODO: implement this later: add image fallback while loading and when error
    if (!src) return null;

    return <img src={src} alt={alt} />;
  }
}
